import { DialogActions as MuiDialogActions } from "@mui/material";
import Button from "../../atoms/Button/Button";

interface DialogActionsProps {
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
}

const DialogActions = ({
  onCancel,
  onConfirm,
  confirmText = "Guardar",
  cancelText = "Cancelar",
}: DialogActionsProps) => {
  return (
    <MuiDialogActions>
      <Button onClick={onCancel} variant="secondary">
        {cancelText}
      </Button>
      <Button onClick={onConfirm} variant="primary">
        {confirmText}
      </Button>
    </MuiDialogActions>
  );
};

export default DialogActions;
